import api from '../../api/nodeBackApi';

export const getCustomerWithCamaras = async (customerId) => {
  try {
    const response = await api.get(`/api/customerDashboard/getall`);
    return response.data;
  } catch (error) {
    console.error("Error fetching customer cameras:", error);
    throw error;
  }
}

export const getWeeklyStats = async (year, week) => {
  try {
    const response = await api.get(`/api/loginRegister/getWeeklyData?year=${year}&week=${week}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching customer cameras:", error);
    throw error;
  }
}


export const customerSatisfactionScore = async (customerId, score) => {

  const data = {
    satisfactionScore: score
  };

  try {
    const response = await api.post(`/api/management/customer/satisfactionScore/${customerId}`, data);
    return response.data;
  } catch (error) {
    console.error("Error fetching customer satisfaction score:", error);
    throw error;
  }
}


export const updateCustomerVisibility = async (customerId, visibleForEditor) => {
  try {
    const response = await api.put(`/api/management/customers/${customerId}`, { visibleForEditor });
    return response.data;
  } catch (error) {
    console.error("Error updating customer visibility:", error);
    throw error;
  }
}


export const deleteCustomer = async (customerId) => {

  try {
    const response = await api.delete(`/api/management/customers/${customerId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting customer:", error);
    throw error;
  }
}
